module.exports = __webpack_public_path__ + "img/logo-img.1c6d1f7f.png";